import { createFileRoute } from '@tanstack/react-router'
import Workstation from "@/features/workstation";

export const Route = createFileRoute('/_authenticated/')({
  component: Workstation,
})
